import React from 'react'

const STATUS_OPTIONS = [
  { value: 'visited', label: 'Visited', color: '#f97316' },
  { value: 'unvisited', label: 'Unvisited', color: '#9ca3af' },
  { value: 'golden', label: 'Favorites', color: '#facc15' },
]

export function StatusFilter({ value, onChange }) {
  const currentValue = value instanceof Set ? value : new Set()

  return (
    <section className="filter-section" aria-label="Status">
      <h2 className="filter-section__title">Status</h2>
      <div className="filter-section__options filter-section__options--status">
        {STATUS_OPTIONS.map(option => {
          const selected = currentValue.has(option.value)
          return (
            <button
              key={option.value}
              type="button"
              aria-pressed={selected}
              aria-current={selected ? 'true' : undefined}
              className={`filter-option${selected ? ' is-selected' : ''}`}
              onClick={() => {
                const next = new Set(currentValue)
                if (selected) {
                  next.delete(option.value)
                } else {
                  next.add(option.value)
                }
                onChange(next)
              }}
            >
              <span
                className="filter-option__swatch"
                style={{ background: option.color }}
                aria-hidden="true"
              />
              <span className="filter-option__label">{option.label}</span>
            </button>
          )
        })}
      </div>
    </section>
  )
}
